import { useState } from "react"

function AddPlantForm({ isOpen, onToggle, onAddPlant }) {

  const [plantName, setPlantName] = useState("");
  const [plantType, setPlantType] = useState("Succulent");
  const [selectedIcon, setSelectedIcon] = useState("🌵");
  const [frequencyDays, setFrequencyDays] = useState(7);
  
  const plantTypes = [
    'Succulent',
    'Tropical',
    'Herb',
    'Flowering',
    'Fern',
    'Cactus',
    'Other'
  ]

  const plantIcons = ['🌵', '🌿', '🌸', '🌳', '🌱', '🍀','🌹', '🌲', '🌴', '🌾']

  function resetForm() {
    setPlantName("");
    setPlantType("Succulent");
    setSelectedIcon("🌵");
    setFrequencyDays(7);
  }

function handleOnSubmit(e) {
  e.preventDefault();
  
  const newPlant = {
    name: plantName,
    type: plantType,
    icon: selectedIcon,
    frequencyDays: Number(frequencyDays)
  };
  
  if (!plantName.trim()) {
    alert("Please enter a plant name");
    return;
  }
  
  onAddPlant(newPlant);
  resetForm();
  onToggle();
}

  return (
    <section className="add-plant-section">
      <button 
        className="add-plant-toggle"
        onClick={() => onToggle()}
      >
        <span className="toggle-icon">{isOpen ? '−' : '+'}</span>
        <span>{isOpen ? 'Cancel' : 'Add New Plant'}</span>
      </button>

      {isOpen && 
      <form className="add-plant-form" onSubmit={handleOnSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="plantName">Plant Name</label>
            <input
              type="text"
              id="plantName"
              placeholder="e.g., My Monstera"
              className="form-input"
              value={plantName}
              onChange={(e) => setPlantName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="plantType">Plant Type</label>
            <select
              id="plantType"
              className="form-select"
              value={plantType}
              onChange={(e) => setPlantType(e.target.value)}
            >
              {plantTypes.map(type => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Choose Icon</label>
            <div className="icon-selector">
              {plantIcons.map(icon => (
                <button
                  key={icon}
                  type="button"
                  className={`icon-option ${selectedIcon === icon ? "selected" : ""}`}
                  onClick={() => setSelectedIcon(icon)}
                >
                  {icon}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="frequency">Water Every</label>
            <div className="frequency-input">
              <input
                type="number"
                id="frequency"
                min="1"
                max="30"
                className="form-input frequency-number"
                value={frequencyDays}
                onChange={(e) => setFrequencyDays(Number(e.target.value))}
              />
              <span className="frequency-label">days</span>
            </div>
          </div>
        </div>

        <button 
          type="submit" 
          className="submit-btn"
        >
          <span>🌱</span> Add Plant
        </button>
      </form>}
    </section>
  )
}

export default AddPlantForm